import { Box, Stack, Typography } from '@mui/material';
import {
  DefaultizedPieValueType,
  PieChart as MuiPieChart,
  PieValueType,
} from '@mui/x-charts';
import { MakeOptional } from '@mui/x-date-pickers/internals';
import React, { FC } from 'react';
import ja from 'utils/ja';

const getArcLabel = (params: DefaultizedPieValueType) => {
  if (!params.value) return '';
  return `${params.value}%`;
};

interface PieChartProps {
  title: string;
  colors: string[];
  data: MakeOptional<PieValueType, 'id'>[];
  label: {
    color: string;
    label: string;
  }[];
}

const PieChart: FC<PieChartProps> = ({ title, colors, data, label }) => {
  return (
    <Stack flexDirection='row'>
      <Box width='60vw' minHeight={280}>
        <Typography
          textAlign='center'
          fontWeight={700}
          sx={{ fontSize: '30px !important' }}
        >
          {title}
        </Typography>
        {!data?.length ? (
          <Stack height='70%' justifyContent='center' alignItems='center'>
            <Typography component='p' textAlign='center' sx={{ width: '80%' }}>
              {ja.message_error.no_data}
            </Typography>
          </Stack>
        ) : (
          <MuiPieChart
            colors={colors}
            margin={{
              top: 20,
              bottom: 20,
              left: 20,
              right: 20,
            }}
            series={[
              {
                innerRadius: 40,
                data: data,
                arcLabel: getArcLabel,
              },
            ]}
            slotProps={{
              legend: { hidden: true },
            }}
            height={260}
            sx={{
              '& .MuiPieArcLabel-root': {
                fontSize: '18px !important',
                fontWeight: '400 !important',
                fill: '#ffffff !important',
              },
            }}
          />
        )}
      </Box>
      <Stack justifyContent='center' flex={1} pl='10px' gap='10px' py='10px'>
        {label.map((item, index) => (
          <Stack key={`lable-${index}`} flexDirection='row' alignItems='center'>
            <Box
              width={35}
              height={35}
              sx={{
                backgroundColor: item.color,
                mr: '10px',
              }}
            />
            <Typography sx={{ fontSize: '25px !important' }}>
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default PieChart;
